module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/thirdStep-f6c370bb3431ee8563f15aae0fd205b4.png";